import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from '../../state';
import { fetchCompanyLogoUrl } from '../companyLogo';

export function useCompanyLogoUrl() {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const { openSettingsModal } = useSelector(
    ({ settingsModalSlice }) => settingsModalSlice,
  );
  const wasSettingsOpenRef = useRef(openSettingsModal);

  const loadCompanyLogo = useCallback(async () => {
    const url = await fetchCompanyLogoUrl();
    setLogoUrl(url);
  }, []);

  useEffect(() => {
    loadCompanyLogo();
  }, [loadCompanyLogo]);

  useEffect(() => {
    if (wasSettingsOpenRef.current && !openSettingsModal) {
      loadCompanyLogo();
    }
    wasSettingsOpenRef.current = openSettingsModal;
  }, [loadCompanyLogo, openSettingsModal]);

  return logoUrl;
}
